import { useMutation } from "react-query";
import downloadUpcCSV from "../services/downloadUpcCSV";

function useDownloadUpcCSV() {
  return useMutation(["download-upc-csv"], downloadUpcCSV);
}

export default useDownloadUpcCSV;
